import { common } from './common';

export const environment = {
  ...common,
  name: 'prod',
  production: true,
  isDebugMode: false,

  url: '',
  apiURL: '',
  ssoURL: '',
  ssoBackEndUrl: '',
  ssoRealm: '',
  apiJWT: '',
};
